import moment from "moment";
import { GLOBAL_VARIABLES } from "./variables";

/**
 * Returns a new File object with its extension normalized to lowercase.
 * This prevents backend rejections when files have uppercase extensions (e.g. .PDF, .JPG).
 */
export function normalizeFileExtension(file) {
	if (!(file instanceof File)) return file;
	const lastDot = file.name.lastIndexOf('.');
	if (lastDot === -1) return file;
	const baseName = file.name.slice(0, lastDot);
	const ext = file.name.slice(lastDot + 1).toLowerCase();
	const normalizedName = `${baseName}.${ext}`;
	if (normalizedName === file.name) return file;
	return new File([file], normalizedName, { type: file.type, lastModified: file.lastModified });
}

/** [start, end) by day; subs beat trial-only (same order as checkmembership). */
export function isMembershipActiveOnDay(item, day = moment().startOf("day")) {
	const d = day.clone().startOf("day");
	const ok = (s, e) =>
		s && e && d.isSameOrAfter(moment(s).startOf("day"), "day") && d.isBefore(moment(e).startOf("day"), "day");
	return ok(item.trial_startTime, item.trial_endTime) || ok(item.sub_startTime, item.sub_endTime);
}

export function shouldDisableTrialDatePickers(row, rows, day = moment().startOf("day")) {
	if (!Array.isArray(rows) || row?.id == null) return false;
	const only = (r, sub) =>
		isMembershipActiveOnDay(
			sub
				? { trial_startTime: null, trial_endTime: null, sub_startTime: r.sub_startTime, sub_endTime: r.sub_endTime }
				: { trial_startTime: r.trial_startTime, trial_endTime: r.trial_endTime, sub_startTime: null, sub_endTime: null },
			day
		);
	const sort = (a, b, k) => new Date(b.createdAt || b[k]) - new Date(a.createdAt || a[k]);
	const pri =
		rows.filter((r) => r.sub_startTime && r.sub_endTime && only(r, true)).sort((a, b) => sort(a, b, "sub_startTime"))[0] ||
		rows.filter((r) => r.trial_startTime && r.trial_endTime && only(r, false)).sort((a, b) => sort(a, b, "trial_startTime"))[0];
	return !!(pri && row.id !== pri.id);
}

const {
	DocumentOptions,
	Options1040,
	Options1065,
	Options1120C,
	Options1120S,
	FormNames1040,
	FormNames1065,
	FormNames1120C,
	FormNames1120S,
	// OptionsTaxPlanningIndividual,
	// FormNamesTaxPlanningIndividual,
	TaxPlaningIndividual,
	TaxPlaningIndividualFormNames,
	OptionsTaxPreperationIndividualCurrentClientShort,
	OptionsTaxPreperationIndividualCurrentClientShortFormNames,
	OptionsTaxPreperationIndividualCurrentClientLong,
	OptionsTaxPreperationIndividualCurrentClientLongFormNames,
	OptionsTaxPreperationIndividualNewClientShort,
	OptionsTaxPreperationIndividualNewClientShortFormNames,

	OptionsTaxPreperationIndividualNewClientLong,
	OptionsTaxPreperationIndividualNewClientLongFormNames,

	OptionsTaxPreperationQuestionnaireBusinessCurrentClientShort,
	OptionsTaxPreperationQuestionnaireBusinessCurrentClientShortFormNames,

	OptionsTaxPreperationQuestionnaireBusinessNewClientShort,
	OptionsTaxPreperationQuestionnaireBusinessNewClientShortFormNames,

	OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong,
	OptionsTaxPreperationQuestionnaireBusinessCurrentClientLongFormNames,

	OptionsTaxPreperationQuestionnaireBusinessNewClientLong,
	OptionsTaxPreperationQuestionnaireBusinessNewClientLongFormNames,

	TaxPlanningBusinessOwner,
	TaxPlanningBusinessOwnerFormNames

} = GLOBAL_VARIABLES;

export const IsLogin = () => {
	if (localStorage.getItem("token")) {
		return true;
	} else {
		return false;
	}
};

// Function that receive two arguments first as array and 2nd as number and tell number is repeted or not
export const isNumberRepeated = (arr, num) => arr.filter((item) => item === num).length > 1;

export const getCurrentFormData = (args) => {
	if (args === DocumentOptions[0].value) return Options1040;
	if (args === DocumentOptions[1].value) return Options1065;
	if (args === DocumentOptions[2].value) return Options1120C;
	if (args === DocumentOptions[3].value) return Options1120S;
	// if (args === DocumentOptions[4].value) return OptionsTaxPlanningIndividual;
	if (args === DocumentOptions[4].value) return TaxPlaningIndividual;

	if (args === DocumentOptions[5].value) return TaxPlanningBusinessOwner;

	if (args === DocumentOptions[6].value) return OptionsTaxPreperationIndividualCurrentClientShort;
	if (args === DocumentOptions[7].value) return OptionsTaxPreperationIndividualCurrentClientLong;
	if (args === DocumentOptions[8].value) return OptionsTaxPreperationIndividualNewClientShort;
	if (args === DocumentOptions[9].value) return OptionsTaxPreperationIndividualNewClientLong;
	if (args === DocumentOptions[10].value) return OptionsTaxPreperationQuestionnaireBusinessCurrentClientShort;
	if (args === DocumentOptions[11].value) return OptionsTaxPreperationQuestionnaireBusinessNewClientShort;
	if (args === DocumentOptions[12].value) return OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong;
	if (args === DocumentOptions[13].value) return OptionsTaxPreperationQuestionnaireBusinessNewClientLong;


};

export const getCurrentFormsObj = (args) => {
	if (args === DocumentOptions[0].value) return FormNames1040;
	if (args === DocumentOptions[1].value) return FormNames1065;
	if (args === DocumentOptions[2].value) return FormNames1120C;
	if (args === DocumentOptions[3].value) return FormNames1120S;
	// if (args === DocumentOptions[4].value) return FormNamesTaxPlanningIndividual;
	if (args === DocumentOptions[4].value) return TaxPlaningIndividualFormNames;

	if (args === DocumentOptions[5].value) return TaxPlanningBusinessOwnerFormNames;

	if (args === DocumentOptions[6].value) return OptionsTaxPreperationIndividualCurrentClientShortFormNames;
	if (args === DocumentOptions[7].value) return OptionsTaxPreperationIndividualCurrentClientLongFormNames;
	if (args === DocumentOptions[8].value) return OptionsTaxPreperationIndividualNewClientShortFormNames;
	if (args === DocumentOptions[9].value) return OptionsTaxPreperationIndividualNewClientLongFormNames;
	if (args === DocumentOptions[10].value) return OptionsTaxPreperationQuestionnaireBusinessCurrentClientShortFormNames;
	if (args === DocumentOptions[11].value) return OptionsTaxPreperationQuestionnaireBusinessNewClientShortFormNames;
	if (args === DocumentOptions[12].value) return OptionsTaxPreperationQuestionnaireBusinessCurrentClientLongFormNames;
	if (args === DocumentOptions[13].value) return OptionsTaxPreperationQuestionnaireBusinessNewClientLongFormNames;
};

export function getSubObjectCount(obj) {
	try {
		let count = 0;
		Object.keys(obj)?.forEach((element) => {
			if (Object.keys(obj[element])?.length > 0) {
				++count;
			}
		});
		return count;
	} catch (error) {
		console.error("Error:", error);
		return 0;
	}
}

export const formatCurrency = (value) => {
	const num = parseFloat(value) || 0;
	const rounded = Math.round(num * 100) / 100;
	const parts = rounded.toFixed(2).split(".");
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	if (parts[1] === "00") return `$${parts[0]}`;
	return `$${parts.join(".")}`;
  };

	export const formatMessagesForAI = (chatData) => {
		return chatData.map(msg => ({
			role: msg.messageType === 'ai/Response' ? 'assistant' : 'user',
			content: msg.body,
		}));
	}
	export const getProjectId = () => {
		const pathSegments = window.location.pathname.split('/');
		return pathSegments[pathSegments.length - 1]; // gets the last segment (project ID)
	};

export function convertTaxPlanToHTML(data) {
  const { client, date, preparedBy, sections } = data;

  const safeText = (text) => (text ? text.replace(/\n/g, "<br>") : "");

  const createList = (items) =>
    items?.length
      ? `<ul class="mb-2 ps-4 text-start" style="list-style-position: outside;">
          ${items.map((item) => `<li class="mb-1">${item}</li>`).join("")}
        </ul>`
      : "";

  const generateTable = (rows, headers) => `
    <table class="table table-striped table-bordered mt-2">
      <thead class="table-light">
        <tr>${headers.map((h) => `<th>${h}</th>`).join("")}</tr>
      </thead>
      <tbody>
        ${rows
          .map(
            (row) =>
              `<tr>${headers.map((key) => `<td>${row[key] || ""}</td>`).join("")}</tr>`
          )
          .join("")}
      </tbody>
    </table>`;

  const sectionCard = (title, content) =>
    content
      ? `<div class="mb-4 p-3 border rounded bg-white shadow-sm">
          <h5 class="text-primary border-bottom pb-2 mb-3 text-center">${title}</h5>
          <div class="text-start">${content}</div>
        </div>`
      : "";

  const headerSection = `
    <div class="mb-4 text-center">
      <h4 class="text-primary">Tax Strategy Plan</h4>
      ${client ? `<p class="mb-1"><strong>Client:</strong> ${client}</p>` : ""}
      ${date ? `<p class="mb-1"><strong>Date:</strong> ${date}</p>` : ""}
      ${
        preparedBy
          ? `<p class="mb-0"><strong>Prepared By:</strong> ${preparedBy}</p>`
          : ""
      }
    </div>`;

  const summarySection = sections?.strategicTaxSummary?.content
    ? `<p>${safeText(sections.strategicTaxSummary.content)}</p>`
    : "";

  const savingsSection = sections?.estimatedTaxSavingsOverview?.strategies
    ? `
    ${generateTable(sections.estimatedTaxSavingsOverview.strategies, [
      "name",
      "year1",
      "5year",
      "10year",
    ])}
    <p class="mt-2 mb-0">
      <strong>Totals:</strong>
      ${sections.estimatedTaxSavingsOverview.totals?.year1 || ""}, 
      ${sections.estimatedTaxSavingsOverview.totals?.["5yearOneTime"] || ""}, 
      ${sections.estimatedTaxSavingsOverview.totals?.["10yearOneTime"] || ""}
    </p>`
    : "";

  const keyStrategies = Array.isArray(sections?.keyStrategies)
    ? sections.keyStrategies
        .map(
          (s) => `
        <div class="mb-3">
          <strong>${s.name}</strong><br/>
          ${s.description ? `<div class="mt-1">${safeText(s.description)}</div>` : ""}
          ${s.steps ? `<div class="mt-1"><strong>Steps:</strong> ${s.steps}</div>` : ""}
        </div>`
        )
        .join("")
    : "";

  const retirementSection = sections?.retirementGrowthOpportunity?.description
    ? `
    <p>${sections.retirementGrowthOpportunity.description}</p>
    <ul class="ps-4 text-start" style="list-style-position: outside;">
      ${
        sections.retirementGrowthOpportunity.projections?.["5years"]
          ? `<li><strong>5 Years:</strong> ${sections.retirementGrowthOpportunity.projections["5years"]}</li>`
          : ""
      }
      ${
        sections.retirementGrowthOpportunity.projections?.["10years"]
          ? `<li><strong>10 Years:</strong> ${sections.retirementGrowthOpportunity.projections["10years"]}</li>`
          : ""
      }
    </ul>`
    : "";

  const roiSection = Array.isArray(sections?.quarterlyVsOneTimeROI?.comparison)
    ? `
    ${generateTable(sections.quarterlyVsOneTimeROI.comparison, [
      "planningModel",
      "year1",
      "5year",
      "10year",
    ])}
    ${
      sections.quarterlyVsOneTimeROI.disclaimer
        ? `<p class="mt-2">${safeText(sections.quarterlyVsOneTimeROI.disclaimer)}</p>`
        : ""
    }`
    : "";

  const nextSteps = createList(sections?.recommendedNextSteps);

  const incomeSummary = sections?.taxableIncomeSummary
    ? `
    ${
      sections.taxableIncomeSummary.filing_status
        ? `<p><strong>Filing Status:</strong> ${sections.taxableIncomeSummary.filing_status}</p>`
        : ""
    }
    ${
      sections.taxableIncomeSummary.taxable_income
        ? `<p><strong>Taxable Income:</strong> $${sections.taxableIncomeSummary.taxable_income}</p>`
        : ""
    }
    ${
      sections.taxableIncomeSummary.estimated_tax_due
        ? `<p><strong>Estimated Tax Due:</strong> $${sections.taxableIncomeSummary.estimated_tax_due}</p>`
        : ""
    }
    ${
      sections.taxableIncomeSummary.deductions
        ? `<div class="mb-2">
            <strong>Deductions:</strong>
            <ul class="ps-4 text-start mb-0" style="list-style-position: outside;">
              <li>Standard: $${sections.taxableIncomeSummary.deductions.standard_deduction}</li>
              <li>Other: $${sections.taxableIncomeSummary.deductions.other_deductions}</li>
            </ul>
          </div>`
        : ""
    }
    ${
      sections.taxableIncomeSummary.recommendations
        ? `<p><strong>Recommendations:</strong></p>${createList(
            sections.taxableIncomeSummary.recommendations
          )}`
        : ""
    }
    ${
      sections.taxableIncomeSummary.notes
        ? `<p><strong>Notes:</strong><br>${safeText(
            sections.taxableIncomeSummary.notes
          )}</p>`
        : ""
    }`
    : "";

  const disclaimer = sections?.importantInformation?.content
    ? `<p>${safeText(sections.importantInformation.content)}</p>`
    : "";

  return `
    <div class="bg-light p-3 rounded" style="max-height: 400px; overflow-y: auto;">
      ${headerSection}
      ${sectionCard("Strategic Tax Summary", summarySection)}
      ${sectionCard("Estimated Tax Savings Overview", savingsSection)}
      ${sectionCard("Key Strategies", keyStrategies)}
      ${sectionCard("Retirement Growth Opportunity", retirementSection)}
      ${sectionCard("Quarterly vs One-Time ROI", roiSection)}
      ${sectionCard("Recommended Next Steps", nextSteps)}
      ${sectionCard("Taxable Income Summary", incomeSummary)}
      ${sectionCard("Important Information", disclaimer)}
    </div>
  `;
}

export function getActiveMembershipCount(data) {
	if (!Array.isArray(data)) return 0;
	const today = moment().startOf("day");
	return data.filter((item) => isMembershipActiveOnDay(item, today)).length;
}

export function getInvoiceDisplayName(invoice) {
	const fallback = invoice?.name ?? '';
	let meta = invoice?.meta_data;
	if (!meta) return fallback;
	if (typeof meta === 'string') {
		try {
			meta = JSON.parse(meta);
		} catch {
			return fallback;
		}
	}
	if (typeof meta !== 'object' || Array.isArray(meta)) return fallback;
	if ((meta.subscription_invoice || meta.susbcription_invoice) && meta.invoice_subscription_name?.toString().trim()) {
		return meta.invoice_subscription_name.toString();
	}

	return fallback;
}



